import axios from 'axios';
import { getUserAccount } from '../../utils/accessTokenData';
import { TOOLBOX_URL, GET_USER_CUSTOM_DATA, SET_USER_CUSTOM_DATA } from '../../utils/env';
import { headers } from '../../services/authService';

export async function fetchUserCustomData() {
  if (!GET_USER_CUSTOM_DATA) return undefined;
  const apiToolbox = axios.create({
    baseURL: TOOLBOX_URL || import.meta.env.VITE_TOOLBOX_URL,
    headers: {
      ...headers(),
      'x-api-key': import.meta.env.VITE_X_API_KEY_TOOLBOX,
    },
  });

  const path = '/maverick/legacy/getUserCustomData';
  const { iso2Code } = await getUserAccount() || {};

  const response = await apiToolbox.post(`${path}`, {
    iso2Code,
  });

  return response.data.customData || {};
}

export async function updateUserCustomData(customData) {
  if (!SET_USER_CUSTOM_DATA) return undefined;

  const apiToolbox = axios.create({
    baseURL: TOOLBOX_URL,
    headers: {
      ...headers(),
      'x-api-key': import.meta.env.VITE_X_API_KEY_TOOLBOX,
    },
  });

  const path = '/maverick/legacy/setUserCustomData';
  const { iso2Code } = await getUserAccount() || {};

  const data = {
    patchOperations: [
      {
        operation: 'replace',
        field: 'userCustomData',
        value: customData,
      },
    ],
  };

  try {
    await apiToolbox.post(`${path}`, {
      iso2Code,
      ...data,
    });
  } catch (error) {
    console.error('Error updating user custom data', error);
    return false;
  }

  return fetchUserCustomData();
}
